import { getData, remove_item_of_arr_with_id } from '../assets/scripts/GeneralFunctions'
import Swal from 'sweetalert2'
import 'sweetalert2/src/sweetalert2.scss'
import { transition_animation } from './stateList'

export const removeSwal = (url, list, id, setList) => {
  // remove Swal
  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      confirmButton: 'm-2 bg-blue text-white rounded-md text-base py-2 px-4 border-2 border-blue',
      cancelButton: `m-2 bg-white hover:bg-cancel text-cancel hover:text-white rounded-md text-base py-2 px-4 border-2 border-cancel ${transition_animation}`,
    },
    buttonsStyling: false,
  })
  swalWithBootstrapButtons
    .fire({
      title: 'آیا مطمئن هستید؟',
      text: 'میخواهید این مورد را حذف کنید',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'نه حذف نشود',
      confirmButtonText: 'بله حذف کن',
      reverseButtons: true,
    })
    .then(async (result) => {
      if (result.isConfirmed) {
        let remove_result = await getData(`${url}/${id}`, 'get', {}, true)
        if (remove_result?.status === 200) {
          setList(remove_item_of_arr_with_id(list, id))

          swalWithBootstrapButtons.fire('حذف شد!', 'با موفقیت حذف شد', 'success')
        }
      }
    })
}
